export const EVENT_CLOSE_MENU = 'event-close-menu';